import styled from "styled-components";
import { Accordion, Box, Typography } from "@mui/material";

const mainColor = "#146cfa";

interface TitleProps {
  $isexpanded: boolean;
}

export const CustomAccordion = styled(Accordion)`
  && {
    background: #ffffff;
    border: 0.5px solid rgba(20, 108, 250, 0.25);
    box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.15);
    border-radius: 4px;
    position: relative;
    padding: 18px;
  }

  &&::before {
    display: none;
  }

  && .MuiAccordionSummary-root {
    min-height: 52px;
    padding: 0;
  }

  && .MuiAccordionSummary-content {
    display: flex;
    align-items: center;
    margin: 0;
  }

  && .MuiAccordionDetails-root {
    padding: 16px 0 0 70px;
  }
`;

export const Content = styled(Box)`
  && {
    display: flex;
    align-items: center;
    position: relative;
  }
`;

export const IconContainer = styled(Box)`
  && {
    background-color: ${mainColor};
    position: absolute;
    left: -18px;
    top: -19px;
    width: 70px;
    height: calc(100% + 38px);
    min-height: 88px;

    display: flex;
    align-items: center;
    justify-content: center;

    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
  }

  @media screen and (max-width: 375px) {
    && {
      min-height: 113px;
    }
  }
`;

export const Icon = styled.img`
  && {
    width: 100%;
    max-width: 58px;
    padding: 14px;
    object-fit: contain;
  }
`;

export const Title = styled(Typography)<TitleProps>`
  && {
    color: ${mainColor};
    font-family: Figtree, sans-serif;
    font-weight: 700;
    margin-left: 70px;
    font-size: 1rem;
    line-height: 1.3;
    transition: color 0.2s ease;
  }

  @media screen and (max-width: 375px) {
    && {
      width: 95px;
    }
  }
`;

export const SubTitle = styled(Typography).attrs({ as: "p" })`
  && {
    margin: 0;
    color: rgba(60, 60, 67, 0.85);
    font-family: Figtree, sans-serif;
    font-weight: 400;
    font-size: 14px;
    line-height: 22px;
  }
`;